import {Component, OnInit} from '@angular/core';
import { ASCIIPipe, CachingService, MailingService, MailConfig, MailAccount, MailingDefault, MailAttachment } from "../../../../../projects/jv-common/src/public_api";
import { BankingService } from "../../../../../projects/accounting/src/lib/services/banking.service";
import {ExcelService} from "../../../../../projects/accounting/src/lib/services/excel.service";
import { MessageBoxComponent } from "../../../../../projects/jv-ui/src/lib/popups/message-box/message-box.component";
import {DatePipe, DecimalPipe} from "@angular/common";
import {BsModalService} from "ngx-bootstrap";


interface MergeTransferInterface {
    depositCache: any,
    transferCache: any,
    serviceTransferCache:any,
    orderGroups: Array<any>
}

@Component({
    selector: 'app-merge-transfer',
    templateUrl: './merge-transfer.component.html',
    styleUrls: ['./merge-transfer.component.scss']
})
export class MergeTransferComponent implements OnInit {
    data: MergeTransferInterface = null;

    private emails = ['aha@ahacafe.vn', 'hoai4285@gmail.com', 'ketoan@ahacafe.vn'];
    // private emails = ['chinhdays@gmail.com'];
    loading = false;
    codes = [];
    constructor(
        private cache: CachingService,
        private banking: BankingService,
        private excel: ExcelService,
        private ascii: ASCIIPipe,
        private date: DatePipe,
        private mail: MailingService,
        private modalService: BsModalService,
        private decimal: DecimalPipe,
    ) {
    }

    ngOnInit() {
        this.loading = true;
        this.load().then( rs => {
            if (rs){
                this.data = {
                    depositCache: rs[0],
                    transferCache: rs[1],
                    serviceTransferCache: rs[2],
                    orderGroups: []
                };
                console.log(this.data);
            }
            this.loading = false;
        })
    }
    async load(){
        let result;
        let pr1 = this.cache.get("last-mass-deposit", { code: null, period: null, date: null, orders: [] }).toPromise();
        let pr2 = this.cache.get("last-mass-transfer", { code: null, period: null, date: null, orders: [] }).toPromise();
        let pr3 = this.cache.get("last-mass-service-transfer", { code: null, period: null, date: null, orders: [] }).toPromise();
        await Promise.all([pr1, pr2, pr3]).then( rs => {
            result = rs;
        });
        if(result){
            return Promise.resolve(result);
        }
    }
    test(event){
        let value: string = event.target.value.toUpperCase();
        this.codes = value.split(' ');
        this.fetchOrders();
    }
    fetchOrders(){
        this.data.orderGroups = [];
        this.codes.forEach( code => {
            if(code == this.data.depositCache.code){
                let cache = JSON.parse(JSON.stringify(this.data.depositCache));
                cache.title = "GHI NHẬN CHI CHO YÊU CẦU TẠM ỨNG THEO LÔ";
                cache.orderType = "Tạm ứng";
                cache.class = "text-warning";
                this.data.orderGroups.push(cache);
            }
            if(code == this.data.transferCache.code){
                let cache = JSON.parse(JSON.stringify(this.data.transferCache));
                cache.title = "GHI NHẬN CHI CHO YÊU CẦU THANH TOÁN THEO LÔ";
                cache.orderType = "Thanh toán công nợ";
                cache.class = "text-success";
                this.data.orderGroups.push(cache);
            }
            if(code == this.data.serviceTransferCache.code){
                let cache = JSON.parse(JSON.stringify(this.data.serviceTransferCache));
                cache.title = "GHI NHẬN CHI CHO YÊU CẦU THANH TOÁN DỊCH VỤ THEO LÔ";
                cache.orderType = "Thanh toán dịch vụ";
                cache.class = "text-primary";
                this.data.orderGroups.push(cache);
            }
        });

    }
    generateAttachments(data: any, periods) {

        let groups = {};

        data.forEach(i => {

            let key = i.group == '' ? "default" : i.group;
            if (typeof groups[key] == "undefined") groups[key] = [];

            groups[key].push(i);
        });

        let results: Array<MailAttachment> = [];

        for (let group in groups) {

            this.banking.sources.forEach(account => {

                let prefix = (group == 'default' ? '' : group.trim().toLocaleUpperCase().replace(/ /g, '_') + '_') + account.name + '_T' + periods.join(', ') + '_T';

                let sender = account.name.lastIndexOf('_') > 0 ? account.name.substr(account.name.lastIndexOf('_') + 1) : 'AHA';

                if (account.internalXLSExtractor == account.externalXLSExtractor) {

                    let orders = this.group(sender, groups[group].filter(i => i.source.name == account.name), Math.min(account.internalLimit, account.externalLimit));

                    for (let i = 0; i < orders.length; i++) {
                        orders[i].forEach( ii => {
                            ii.internal = ii.source.globalBankName == ii.target.globalBankName;
                        });
                        results.push({
                            filename: prefix + (i + 1) + '_' + orders.length + '.xls',
                            base64Content: this.excel.jsonToBase64XLS(account.internalXLSExtractor(account, orders[i]))
                        });

                        orders[i].forEach(o => o.file = prefix + (i + 1) + '_' + orders.length);
                    }
                }
                else {

                    let internal = this.group(sender, groups[group].filter(i => {
                        return i.source.name == account.name && i.source.globalBankName == i.target.globalBankName;
                    }), account.internalLimit);

                    for (let i = 0; i < internal.length; i++) {

                        results.push({
                            filename: 'NB_' + prefix + (i + 1) + '_' + internal.length + '.xls',
                            base64Content: this.excel.jsonToBase64XLS(account.internalXLSExtractor(account, internal[i]))
                        });

                        internal[i].forEach(o => o.file = 'NB_' + prefix + (i + 1) + '_' + internal.length);
                    }

                    let external = this.group(sender, groups[group].filter(i => {
                        return i.source.name == account.name && i.source.globalBankName != i.target.globalBankName
                    }), account.externalLimit);

                    for (let i = 0; i < external.length; i++) {

                        results.push({
                            filename: 'LNH_' + prefix + (i + 1) + '_' + external.length + '.xls',
                            base64Content: this.excel.jsonToBase64XLS(account.externalXLSExtractor(account, external[i]))
                        });

                        external[i].forEach(o => o.file = 'LNH_' + prefix + (i + 1) + '_' + external.length);
                    }
                }
            });
        }

        return results;
    }
    group(sender: string, source: Array<any>, limit: number) {

        let results = [];

        for (let i = 0; i < source.length; i++) {

            let count = Math.ceil(source[i].amount / limit);
            let part = 1;

            let clone = {
                notes: this.ascii.transform(sender + ' TT ' + source[i].info.name + (count > 1 ? ' LAN ' + count + ' TREN ' + count : '')).toUpperCase() + (source[i].notesCache && source[i].notesCache.length > 0 ? ' ' +source[i].notesCache : ''),
                amount: source[i].amount
            };

            source[i].parts = [];

            for (let o in source[i]) if (typeof clone[o] == "undefined") clone[o] = source[i][o];

            source[i].parts.push(clone);

            while (clone.amount > limit) {

                clone.amount -= limit;

                let order = {
                    notes: this.ascii.transform(sender + ' TT ' + source[i].info.name + (count > 1 ? ' LAN ' + part + ' TREN ' + count : '')).toUpperCase() + (source[i].notesCache && source[i].notesCache.length > 0 ? ' ' +source[i].notesCache : ''),
                    amount: limit
                };

                for (let o in clone) if (typeof order[o] == "undefined") order[o] = clone[o];

                results.push([order]);
                source[i].parts.push(order);

                part++;
            }

            source[i] = clone;
        }

        // remove invalid requests
        let left = source.filter(i => i.amount > 0).sort((a, b) => a.amount > b.amount ? -1 : 1);

        // get orders
        while (left.length > 0) {

            let trace = this.maxsub(0, left, limit).trace;
            let order = [];

            while (trace != null) {

                order.push(left[trace.index]);
                left[trace.index] = null;
                trace = trace.next;
            }

            left = left.filter(i => i != null);

            results.push(order.sort((a, b) => a.amount > b.amount ? -1 : 1));
        }

        return results;
    }
    maxsub(index: number, source: Array<any>, limit: number) {

        switch (source.length - index) {

            case 0:
                return { trace: null, sum: 0 };

            case 1:
                return source[index].amount > limit ? { trace: null, sum: 0 } : {
                    trace: { index: index, next: null },
                    sum: source[index].amount
                };

            default:

                let result = { trace: { index: index, next: null }, sum: 0 };

                let nextlimit = limit - source[index].amount;

                for (let i = source.length - 1; i > index; i--) {

                    if (source[i].amount > nextlimit) break;

                    let test = this.maxsub(i, source, nextlimit);

                    if (test.sum > result.sum) {

                        result.sum = test.sum;
                        result.trace.next = test.trace;
                    }
                }

                result.sum += source[index].amount;

                return result;
        }
    }
    send(){
        this.loading = true;
        this.createMail().then(mail => {
            this.mail.send(mail, succeed => {
                this.loading = false;
                this.modalService
                    .show(MessageBoxComponent, {
                        class: 'modal-md', initialState: {
                            data: {
                                content: succeed
                                    ? '<div class="text-success text-center"><b>Yêu cầu gộp thanh toán công nợ theo lô đã được gửi thành công.</b></div>'
                                    : '<div class="text-danger text-center"><b>Có lỗi không gửi được mail, vui lòng thử lại</b></div>',
                                buttons: [{ name: 'OK', class: succeed ? 'bg-success' : 'bg-danger' }]
                            }
                        }
                    });
            });
        });

    }
    createMail(): Promise<MailConfig> {

        return new Promise<MailConfig>(resolve => {
            let dataEx = [];
            let periods = [];
            this.data.orderGroups.forEach( g => {
                if(periods.filter(i => i == g.period).length == 0){
                    periods.push(g.period);
                }
                g.orders.filter( i => {
                    i.group = '';
                    i.orderType = g.orderType;
                    i.class = g.class;
                    dataEx.push(i);
                })
            });
            setTimeout(() => {
                let mail: MailConfig = {
                    receivers: this.emails,
                    name: 'Kế Toán AHA',
                    account: MailAccount.Report,
                    subject: '[' + this.date.transform(new Date(), 'dd/MM/yy HH:mm:ss') + '] ' + 'Gộp yêu cầu thanh toán công nợ theo lô cho nhà cung cấp T' + periods.join('_T'),
                    content: '',
                    css: MailingDefault.Style
                };

                mail.attachments = this.generateAttachments(dataEx, periods);
                this.banking.sources.forEach(account => {
                    let buffer = dataEx.filter(i => i.source.name == account.name);
                    if (buffer.length > 0) mail.content += this.generateDetailsReport('CHI TIẾT LỆNH CHUYỂN KHOẢN TỪ ' + account.name, buffer);
                });

                mail.content += this.generateDetailsReport('CHI TIẾT LỆNH CHUYỂN KHOẢN THEO NHÀ CUNG CẤP', dataEx);

                let code = (new Date().getTime() % 10000).toString();
                while (code.length < 4) code = '0' + code;

                let cachingData = {
                    code: 'T' + code,
                    period: periods.join('_'),
                    orders: [],
                    date: new Date().getTime()
                };
                mail.content += '<div style="background-color:lightgray; padding: 10px; margin-top: 10px; text-align: center"><small>CÁC MÃ XÁC NHẬN LỆNH: </small><br><b>' + this.codes.join(' - ') + '</b></div>';
                resolve(mail);
            }, 200);
        });
    }

    generateDetailsReport(title, data) {
        let html = '<p>' + title + '</p>'
        html += '<table>';
        html += '<thead>';
        html += '<tr>';
        html += '<th class="text-left">Nhà cung cấp</th>';
        html += '<th class="text-left">TK Gửi</th>';
        html += '<th class="text-left">TK Nhận</th>';
        html += '<th class="text-right">Số tiền</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';

        let amount = 0;
        let required = 0;
        let excess = 0;
        let debt = 0;

        data.forEach(order => {

            amount += order.amount;

            for (let i = 0; i < order.parts.length; i++) {

                let part = order.parts[i];

                html += '<tr>';
                if (i == 0) {
                    html += '<td rowspan="' + (order.parts.length > 1 ? order.parts.length + 1 : 1) + '"><b>' + order.info.name + '</b><br/><small>' + order.info.address + '</small><br/><small class="'+order.class+'">'+order.orderType+'</small></td>';
                }

                html += '<td><b>' + part.source.name + '</b><br/><small>' + part.file + '</small></td>';
                html += '<td><b>' + part.target.owner + ' (' + part.target.account + ')</b><br/><small>' + part.target.globalBankName + ' - ' + part.target.globalBranchName + '</small ></td>';
                html += '<td class="text-right text-danger">' + (order.parts.length == 1 ? '<b>' : '') + this.decimal.transform(part.amount, "1.0-0", "en-US") + (order.parts.length == 1 ? '</b>' : '') + '</td>';

                html += '</tr>';
            }

            if (order.parts.length > 1) {
                html += '<tr>';
                html += '<td colspan="2" class="text-left"><b>TỔNG</b></td>';
                html += '<td class="text-right text-danger"><b>' + this.decimal.transform(order.amount, '1.0-0', 'en-US') + '</b></td>';
                html += '</tr>';
            }
        });

        html += '<tr>';
        html += '<td colspan="3"><b>TỔNG</b></td>';
        html += '<td class="text-right text-danger"><b>' + this.decimal.transform(amount, '1.0-0', 'en-US') + '</b></td>';
        html += '</tr>';

        html += '</tbody></table>';

        return html;
    }

}
